import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Button, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * One button, two doors.
 *
 *     Split a bill        →  /new/money
 *     Ask who's coming    →  /new/rsvp
 *     Start a group       →  /new/group
 *
 * **Not "Collect money".** We never collect it — participants pay each other
 * directly — and a menu item promising otherwise is exactly the
 * money-transmitter framing this product exists to avoid. Verb-first on both
 * sides: what the organiser does, not what the system does.
 *
 * `docs/SHAPES.md` objected to a picker, and this is not one. A picker is a
 * screen that stops you with "choose a type" before you have typed anything;
 * two labelled doors on a button somebody already reached for are a menu.
 * Nobody opens this app unsure whether they need money back or a headcount.
 *
 * The third door is the standing roster — the people you play with every
 * week, which is one thing that lasts rather than one campaign a session. It
 * is last because it is the rarest, and it is the LAST door this menu gets:
 * SHAPES.md's argument still binds, and the fifth type costs more than the
 * fourth.
 */
export function NewCampaignButton() {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const navigate = useNavigate()

  const go = (to: string) => {
    setAnchor(null)
    navigate(to)
  }

  return (
    <>
      <Button
        variant="contained"
        endIcon={<ArrowDropDownIcon />}
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={anchor ? 'true' : undefined}
      >
        New
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem onClick={() => go('/new/money')}>Split a bill</MenuItem>
        <MenuItem onClick={() => go('/new/rsvp')}>Ask who&apos;s coming</MenuItem>
        <MenuItem onClick={() => go('/new/group')}>Start a group</MenuItem>
      </Menu>
    </>
  )
}
